import { Injectable } from '@angular/core';
import { UiService } from 'app/helper-components/UiService';
import { PostService } from 'app/helpers/post.service';
import { UserDataService } from 'app/helpers/user-data.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  partyPosts = null;
  pages = null;
  public alertData: any = [];

  constructor(
    private userDataService: UserDataService,
    private postService: PostService,
    private uiService: UiService,
  ) { }

  fetchAlerts() {

    var postId = [];
    for (var i = 0; i < this.userDataService.userData.party_posts?.length ?? 0; i++) {
      var postStatus = this.userDataService.userData.party_posts[i].status;
      if (postStatus == 98 || postStatus == 147) {
        postId.push(this.userDataService.userData.party_posts[i].party_post_subgroup_id);
      }
      this.partyPosts = postId;
    }

    if (this.partyPosts != null) {
      const formData = new FormData();
      formData.append("getAlerts", "1");
      formData.append("alert_type", "1");
      formData.append("party_posts", JSON.stringify(this.partyPosts));

      return this.postService.post(environment.API_ALERTS, formData);

    }
  }
}
